import { render, staticRenderFns } from "./quarterly-sale-product-by-customer.vue?vue&type=template&id=32715f3d"
import script from "./quarterly-sale-product-by-customer.vue?vue&type=script&lang=js"
export * from "./quarterly-sale-product-by-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports